"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var isInteger_1 = __importDefault(require("lodash/isInteger"));
var AdminFutureSessionsController = /** @class */ (function () {
    function AdminFutureSessionsController($scope, $window, FlashService, CalendarModel, FutureEntitiesRepository, filterOptions, serviceArea, instructors, vehicles, UsersModel) {
        var _this = this;
        this.$scope = $scope;
        this.$window = $window;
        this.FlashService = FlashService;
        this.CalendarModel = CalendarModel;
        this.FutureEntitiesRepository = FutureEntitiesRepository;
        this.UsersModel = UsersModel;
        this.today = new Date();
        this.loading = true;
        this.busy = false;
        this.currentPage = 1;
        this.per_page = 20;
        this.totalItems = 0;
        this.conflicts = [];
        this.entities = [];
        this.days = {
            sunday: "sunday",
            monday: "monday",
            tuesday: "tuesday",
            wednesday: "wednesday",
            thursday: "thursday",
            friday: "friday",
            saturday: "saturday",
        };
        this.sectors = serviceArea.sectors;
        this.zones = serviceArea.zones.sort(function (a, b) { return a.name.localeCompare(b.name); }); //alphabetize
        filterOptions.services = filterOptions.services.filter(function (service) {
            return (service.isDriveSession === true ||
                service.name === "All" ||
                service.name === "Events" ||
                service.type === "course");
        });
        this.filterOptions = filterOptions;
        this.filter = {
            startDate: new Date(),
            endDate: null,
            service: this.filterOptions.services[0],
        };
        this.getFilterParams = this.getFilterParams.bind(this);
        this.handleEntities = this.handleEntities.bind(this);
        this.handleAdminActionResponse = this.handleAdminActionResponse.bind(this);
        this.processEntities = this.processEntities.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);
        this.pageChanged = this.pageChanged.bind(this);
        this.reassignInstructor = this.reassignInstructor.bind(this);
        this.reassignZones = this.reassignZones.bind(this);
        this.reassignVehicle = this.reassignVehicle.bind(this);
        this.toggleAllSectorsInZone = this.toggleAllSectorsInZone.bind(this);
        this.isDriveSession = this.isDriveSession.bind(this);
        this.isCourse = this.isCourse.bind(this);
        this.isEvent = this.isEvent.bind(this);
        this.openReassignEntitiesModal = this.openReassignEntitiesModal.bind(this);
        this.selectionHasStudents = false;
        this.selection = [];
        this.applyingFilter = false;
        this.reassignInstructorModalShown = false;
        this.reassignZonesModalShown = false;
        this.reassignVehicleModalShown = false;
        this.selectedInstructor = {}; //used for reassign instructor modal
        this.selectedSectors = []; //used for reassign zones modal
        this.selectedVehicle = {}; //used for reassign vehicle modal
        this.instructors = instructors;
        this.instructors.unshift({
            fullname: "All",
            firstname: "All",
        }, {
            fullname: "None",
            firstname: "None",
        });
        this.instructor = this.instructors[0];
        this.vehicles = vehicles;
        this.vehicles.unshift({
            name: "All",
        }, {
            id: 0,
            name: "None",
        });
        this.vehicle = this.vehicles[0];
        CalendarModel.getFutureEntities(this.getFilterParams()).then(this.handleEntities);
        this.$scope.$watch("vm.entities|filter:{selected:true}", function (nv) {
            _this.selectionHasStudents = false;
            if (typeof nv !== "undefined") {
                // @ts-ignore
                _this.selection = nv.map(function (entity) {
                    if ((0, isInteger_1.default)(entity.student_id)) {
                        _this.selectionHasStudents = true;
                    }
                    return entity;
                });
            }
        }, true);
    }
    AdminFutureSessionsController.prototype.selectAll = function () {
        var _this = this;
        this.entities.forEach(function (entity, index) {
            _this.entities[index].selected = !_this.entities[index].selected;
        });
    };
    AdminFutureSessionsController.prototype.isDriveSession = function (item) {
        return item.type === "Drive Session";
    };
    AdminFutureSessionsController.prototype.isCourse = function (item) {
        return item.type === "Course";
    };
    AdminFutureSessionsController.prototype.isEvent = function (item) {
        return item.type === "Event";
    };
    AdminFutureSessionsController.prototype.openReassignEntitiesModal = function (type) {
        if (type === void 0) { type = "instructor"; }
        if (type === "instructor") {
            this.reassignInstructorModalShown = true;
        }
        if (type === "zones") {
            this.reassignZonesModalShown = true;
        }
        if (type === "vehicle") {
            this.reassignVehicleModalShown = true;
        }
    };
    AdminFutureSessionsController.prototype.reassignInstructor = function () {
        var _this = this;
        this.FutureEntitiesRepository.reassign({
            entities: this.selection,
            instructor: this.selectedInstructor,
        }).then(function (response) {
            _this.handleAdminActionResponse(response);
            _this.closeModal("instructor");
        });
    };
    AdminFutureSessionsController.prototype.reassignZones = function () {
        var _this = this;
        var sectors = this.sectorsSelected();
        this.FutureEntitiesRepository.reassign({
            entities: this.selection,
            sectors: sectors.map(function (sector) {
                delete sector.geom;
                return sector;
            }),
        })
            .then(function (response) {
            _this.handleAdminActionResponse(response);
            _this.closeModal("zones");
        })
            .catch(function (error) { });
    };
    AdminFutureSessionsController.prototype.reassignVehicle = function () {
        var _this = this;
        this.FutureEntitiesRepository.reassign({
            entities: this.selection,
            vehicle: this.selectedVehicle,
        })
            .then(function (response) {
            _this.handleAdminActionResponse(response);
            _this.closeModal("vehicle");
        })
            .catch(function (error) { });
    };
    AdminFutureSessionsController.prototype.toggleAllSectorsInZone = function (zone) {
        var _this = this;
        var removingSectors = this.selectedSectors.filter(function (sector) { return sector.zone_id === zone.id; })
            .length > 0;
        if (removingSectors) {
            this.sectors.forEach(function (sector, index) {
                if (zone.id === sector.zone_id) {
                    delete _this.selectedSectors[index];
                }
            });
        }
        else {
            this.sectors.forEach(function (sector, index) {
                if (zone.id === sector.zone_id) {
                    _this.selectedSectors[index] = sector;
                }
            });
        }
    };
    AdminFutureSessionsController.prototype.sectorsSelected = function () {
        if (this.selectedSectors.length === 0) {
            return [];
        }
        return this.selectedSectors.filter(function (sector) { return sector !== null; });
    };
    AdminFutureSessionsController.prototype.closeModal = function (type) {
        if (type === void 0) { type = "instructor"; }
        if (type === "instructor") {
            this.selectedInstructor = {};
            this.reassignInstructorModalShown = false;
        }
        else if (type === "zones") {
            this.selectedSectors = [];
            this.reassignZonesModalShown = false;
        }
        else if (type === "vehicle") {
            this.selectedVehicle = {};
            this.reassignVehicleModalShown = false;
        }
    };
    AdminFutureSessionsController.prototype.processEntities = function (entity) {
        if (this.isDriveSession(entity)) {
            entity.hasStudent = (0, isInteger_1.default)(entity.student_id) === true ? "Yes" : "No";
        }
        return entity;
    };
    AdminFutureSessionsController.prototype.handleEntities = function (response) {
        this.entities = response.data.map(this.processEntities);
        this.totalItems = response.total;
        this.currentPage = response.current_page;
        this.loading = false;
        this.busy = false;
    };
    AdminFutureSessionsController.prototype.clearConflicts = function () {
        this.conflicts = [];
        this.FlashService.clearFlash();
    };
    AdminFutureSessionsController.prototype.getFilterParams = function () {
        var startDate = (0, moment_1.default)(this.filter.startDate).format("MM/DD/YYYY");
        var days_of_week = [];
        for (var property in this.days) {
            if (this.days[property] !== "none") {
                days_of_week.push(property);
            }
        }
        var filters = {
            instructor: this.instructor.id,
            start_date: startDate,
            end_date: null,
            service: JSON.stringify(this.filter.service),
            context: "future-sessions",
            days_of_week: days_of_week.join(","),
            vehicle: this.vehicle.id,
            page: this.currentPage,
            page_by: this.per_page
        };
        if (this.filter.endDate) {
            filters.end_date = (0, moment_1.default)(this.filter.endDate).format("MM/DD/YYYY");
        }
        if (this.instructor.firstname === "None") {
            filters.instructor = 0;
        }
        if (typeof filters.instructor === "undefined") {
            delete filters.instructor;
        }
        if (this.vehicle.name === "None") {
            filters.vehicle = 0;
        }
        if (typeof filters.vehicle === "undefined") {
            delete filters.vehicle;
        }
        if (!filters.end_date) {
            delete filters.end_date;
        }
        return filters;
    };
    AdminFutureSessionsController.prototype.submitFilter = function () {
        this.busy = true;
        this.CalendarModel.getFutureEntities(this.getFilterParams()).then(this.handleEntities);
    };
    /**
     * ALL OF THE ACTIONS!
     */
    AdminFutureSessionsController.prototype.deleteEntities = function () {
        var confirm = this.$window.confirm("Are you sure you want to deleted the selected entities?");
        if (!confirm) {
            return;
        }
        this.FutureEntitiesRepository.destroy(this.selection).then(this.handleAdminActionResponse);
    };
    AdminFutureSessionsController.prototype.handleAdminActionResponse = function (response) {
        this.busy = true;
        this.FlashService.setMessage({
            type: response.type,
            message: response.message,
        });
        if (response.hasOwnProperty("conflicts")) {
            this.conflicts = response.conflicts;
        }
        // reload entities collection
        if (typeof this.instructor !== "undefined") {
            this.submitFilter();
        }
        else {
            this.CalendarModel.getFutureEntities().then(this.handleEntities);
        }
    };
    AdminFutureSessionsController.prototype.showEntities = function () {
        this.FutureEntitiesRepository.show(this.selection).then(this.handleAdminActionResponse);
    };
    AdminFutureSessionsController.prototype.hideEntities = function () {
        this.FutureEntitiesRepository.hide(this.selection).then(this.handleAdminActionResponse);
    };
    AdminFutureSessionsController.prototype.updateEndDate = function (newDate) {
        this.filter.endDate = newDate.selected[0];
    };
    AdminFutureSessionsController.prototype.updateStartDate = function (newDate) {
        this.filter.startDate = newDate.selected[0];
    };
    AdminFutureSessionsController.prototype.pageChanged = function () {
        this.busy = true;
        this.CalendarModel.getFutureEntities(this.getFilterParams()).then(this.handleEntities);
    };
    return AdminFutureSessionsController;
}());
AdminFutureSessionsController.$inject = [
    "$scope",
    "$window",
    "FlashService",
    "CalendarModel",
    "FutureEntitiesRepository",
    "filterOptions",
    "serviceArea",
    "instructors",
    "vehicles",
    "UsersModel",
];
exports.default = AdminFutureSessionsController;
